import { RouterModule, Routes } from '@angular/router';
import { CustomMetaGuard } from '@shared/shared-meta/custom-meta.guard';
import { ApiSessionKeyGuard } from '@cakeiteasy/web-utils';
import { WrapperComponent } from './components/wrapper/wrapper.component';

const routes: Routes = [
  {
    path: '',
    component: WrapperComponent,
    canActivateChild: [CustomMetaGuard],
    children: [
      {
        path: '',
        canActivate: [ApiSessionKeyGuard],
        loadChildren: () => import('./entire/entire.module').then(m => m.EntireModule)
      },
      { path: 'mock', loadChildren: () => import('./mock-server-browser/mock-server-browser.module').then(m => m.MockServerBrowserModule) }
    ]
  }
];
// must use {initialNavigation: 'enabled'}) - for one load page, without reload
export const AppRoutes = RouterModule.forRoot(routes, {
  // initialNavigation: 'enabledNonBlocking'
  initialNavigation: 'enabledBlocking',
});
